var acVideo = acVideo || {};
var YTPlayer = require('luminoslabs/_yt-player');

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.videoModule = function( options ) {
        return this.each(function() {
            var videoModule = Object.create(acVideo.videoModule);
            videoModule.init(this, options);
        });
    };

    $.fn.videoModule.options = {
        isSlider: false,
        sliderDiv: ".video-slider__slider"
     };

    acVideo.videoModule = {
        init(elem, options) {
            var self = this;
            self.$container = $(elem);

            self.options = $.extend({}, $.fn.showHide.options, options);
            self.$type = self.$container.attr("data-video-type");
            self.$video = self.$container.attr("data-video-id");
            self.$videoDiv = self.$container.find(".video-module__wrapper");

            if (self.$type === 'youtube' && self.isIosWithIssue()) {
                const iframeStr =
                    `<iframe src="https://www.youtube.com/embed/${self.$video}" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
                self.$videoDiv.html(iframeStr);
                return;
            }

            if (self.$type === 'vimeo' && self.isIE10()) {
                const iframeStr =
                    `<iframe src="https://player.vimeo.com/video/${self.$video}?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
                self.$videoDiv.html(iframeStr);
                return;
            }

            self.$thumbnail = self.$container.find(".video-content__image");
            self.$title = self.$container.find(".video-content__title");
            self.$content = self.$container.find(".video-content");
            self.$duration = self.$container.find(".video-content__time");
            self.$videoDiv = self.$container.find(".video-module__wrapper");
            self.$trigger = self.$container.find(".video-content__button");

            switch (self.$type) {
                case 'vimeo':
                    self.bindVimeoElements();
                    break;
                case 'youtube':
                    self.bindYoutubeElements();
                default:
                    break;
            }
        },

        bindVimeoElements() {
            var self = this,
                thumbnailWidth = self.getThumbnailWidth();

            // Ajax Call to get Video Info For Thumbnail, Duration, and title
            $.ajax({
                type:'GET',
                url: 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + self.$video + '&width=' + thumbnailWidth,
                jsonp: 'callback',
                dataType: 'jsonp',

                success: function(data){
                    self.setVimeoVideo();
                    self.$content.css('background-image', 'url(' + data.thumbnail_url + ')');
                    self.$title.text( data.title );
                    self.$duration.text( self.convertVimeoDurationToTime(data.duration) );
                }
            });
        },

        bindYoutubeElements() {
            const self = this;

            $.ajax({
                type: 'GET',
                url: 'https://www.googleapis.com/youtube/v3/videos',
                data: {
                    key: 'AIzaSyDqjaX9ly_IMTWOsDLiKddLpT4WW7qWDkU',
                    id: self.$video,
                    part: 'snippet,contentDetails'
                },
                dataType: 'json',
                cache: false
            })
            .done(function (data) {
                const title = data.items[0].snippet.title;
                const duration = self.convertYoutubeDurationToTime(data.items[0].contentDetails.duration);
                const thumbnail = self.chooseYoutubeThumbnail(data.items[0].snippet.thumbnails);

                self.setYoutubeVideo();
                self.$content.css('background-image', 'url(' + thumbnail.url + ')')
                self.$title.text(title);
                self.$duration.text(duration);
            });
        },

        setVimeoVideo(data) {
            var self = this;
            var options = {
                id: self.$video,
                width: 1400,
                loop: false,
                byline : false,
                title: false,
                portrait: false
            };

            self.$player = new Vimeo.Player(self.$videoDiv[0], options);

            self.$player.ready()
                .then(function() {
                    self.$videoDiv.fadeOut( 100 );
                    self.$trigger.on("click", function() {
                        self.showVideo();
                    });
                });
        },

        convertVimeoDurationToTime(total) {
            var minutes = Math.floor(total / 60);
            var seconds = total % 60; // 30
            var string =  (minutes !== 0 ? (minutes + ":") : '0:') + seconds;
            return string;
        },

        setYoutubeVideo() {
            const self = this;
            const opts = {
                width: 1280,
                height: 720,
                autoplay: false,
                loop: false
            };

            const ytElem = self.$videoDiv.find('.youtube-iframe');
            const player = new YTPlayer(ytElem[0], opts);

            player.load(self.$video, false);
            player.setVolume(100);
            self.$videoDiv.fadeOut(100);

            self.$trigger.on("click", function() {
                self.$videoDiv.fadeIn(300);
                player.play();
            });
        },

        convertYoutubeDurationToTime(duration) {
            const reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
            let hours = 0, minutes = 0, seconds = 0;

            if (reptms.test(duration)) {
                const matches = reptms.exec(duration);
                if (matches[1]) hours = Number(matches[1]);
                if (matches[2]) minutes = Number(matches[2]);
                if (matches[3]) seconds = Number(matches[3]);
            }

            const hoursStr = hours ? (hours + ":") : '';
            const minutesStr = minutes ? (minutes + ":") : '0:';
            return (hoursStr + minutesStr + seconds);
        },

        chooseYoutubeThumbnail(thumbnails) {
            const self = this;
            const thumbnailWidth = self.getThumbnailWidth();
            let thumbnail;

            if (thumbnailWidth <= 480) {
                thumbnail = thumbnails.medium;
            } else if (thumbnailWidth <= 640) {
                thumbnail = thumbnails.high;
            } else if(thumbnailWidth <= 991) {
                thumbnail = thumbnails.standard;
            } else {
                thumbnail = thumbnails.maxres;
            }

            return thumbnail;
        },

        hideVideo() {
            var self = this;
            self.$videoDiv.fadeOut( 300 );

            switch (self.$type) {
                case 'vimeo':
                    self.$player.pause();
                    break;
                case 'youtube':
                    self.$player.pauseVideo();
                    break;
            }
        },

        showVideo() {
            var self = this;
            self.$videoDiv.fadeIn( 300 );

            switch (self.$type) {
                case 'vimeo':
                    self.$player.play();
                    break;
                case 'youtube':
                    self.$player.playVideo();
                    break;
            }
        },

        getThumbnailWidth() {
            const devicePixelRatio = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;
            const windowWidth = $(window).width();

            return Math.round(devicePixelRatio * windowWidth);
        },

        getiOSversion() {
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            }

            return 0;
        },

        isIosWithIssue() {
            const self = this;
            const iosVersion = self.getiOSversion();
            return (iosVersion && iosVersion[0] < 10 && iosVersion[0] > 6)
        },

        isIE10() {
           return navigator.appVersion.indexOf("MSIE 10") !== -1;
        }
    }
});
